import { extend, override } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import ComposerPostPreview from 'flarum/forum/components/ComposerPostPreview';

function replaceTextNodesSpaces(element: HTMLElement) {
  function recurse(node: Node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent) {
        node.textContent = node.textContent.replace(/ /g, '\u00A0');
      }
    } else {
      node.childNodes.forEach((child) => recurse(child));
    }
  }

  recurse(element);

  // // 正则表达式用于匹配HTML标签及其内容，不匹配标签外的内容
  // return html.replace(/<([^\/>]+)>(.*?)<\/\1>/gs, function (match, tag, content) {
  //   // 递归处理嵌套的标签
  //   const replacedContent = replaceSpacesInHTML(content);
  //   // 替换标签内的空格为&nbsp;
  //   const formattedContent = replacedContent.replace(/ /g, '&nbsp;');
  //   return `<${tag}>${formattedContent}</${tag}>`;
  // });
}

export default function () {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    if (items.has('share-social')) {
      items.setPriority('share-social', 70);
    }
    if (items.has('lastDiscussionViewers')) {
      // @ts-ignore
      const views = this.discussion.views();
      const lastViewers = items.get('lastDiscussionViewers');
      delete lastViewers.attrs.label;

      lastViewers.children.forEach((item: any, index: number) => {
        if (item.children.length === 1) {
          // 非访客
          item.children[0].children[1].children[0].children = views[index].user().displayName();
        }
      });

      lastViewers.children.unshift(
        <div key="0" className="LastDiscussionUsers-title">
          <span className="LastDiscussionUsers-title-icon">
            <i className="icon fas fa-shoe-prints" />
          </span>
          <span className="LastDiscussionUsers-title-label">足迹</span>
        </div>
      );
    }
  });

  extend(CommentPost.prototype, 'onupdate', function (vnode) {
    const $img = this.$('.Post-body img');

    $img.each(function () {
      const image = this as HTMLImageElement;
      const height = image.height;
      const width = image.width;

      if (height / width >= 5) {
        image.style.maxHeight = 'max-content';
      }
    });
  });

  /**
   * @since 2024-08-11 替换空格为&nbsp;
   * 多个空格不合并显示，换行保留默认white-space: normal的逻辑
   */
  extend(CommentPost.prototype, 'content', function (nodes) {
    const postBodyNode = nodes.find((item: any) => item.attrs.className.includes('Post-body'));

    clearTimeout(this.replaceSpacesTimer);

    this.replaceSpacesTimer = setTimeout(() => {
      if (postBodyNode?.dom) {
        replaceTextNodesSpaces(postBodyNode.dom);
      }
    }, 10);
  });

  /**
   * @since 2024-08-11 替换空格为&nbsp;
   * 同上，这里是处理编辑器preview的内容
   */
  extend(ComposerPostPreview.prototype, 'oncreate', function (_, vnode: any) {
    clearInterval(this.updateInterval);
    let preview: string | undefined;
    const updatePreview = () => {
      // Since we're polling, the composer may have been closed in the meantime,
      // so we bail in that case.
      if (!this.attrs.composer.isVisible()) return;

      const content = this.attrs.composer.fields.content();

      if (preview === content) return;

      preview = content;

      // @ts-ignore
      this.attrs.surround(() => s9e.TextFormatter.preview(preview || '', vnode.dom));

      replaceTextNodesSpaces(vnode.dom);
      // vnode.dom.innerHTML = replaceSpacesInHTML(vnode.dom.innerHTML);
    };
    updatePreview();

    this.updateInterval = setInterval(updatePreview, 50);
  });

  /**
   * @since 2024-08-25 隐藏帖子详情里的点赞点灭按钮
   */
  extend(CommentPost.prototype, 'actionItems', function (items) {
    items.remove('votes');
  });
}
